export const FocusDirective = {
  mounted (el:HTMLInputElement):void {
    setTimeout(() => {
      el.focus()
    }, 1)
  }
}
